
export type GetPostNetworksModerationTableFilters = GetPostNetworksModerationTabsFilters & {
  tab: string;
};

export type GetPostNetworksModerationTabsFilters = {
  text?: string;
};

export enum NetworkSharePostTypes {
  Job = 'Job',
  Resource = 'Resource'
};

export enum PostNetworksModerationTabs {
  Pending = 'Pending',
  Published = 'Published',
  Dismissed = 'Dismissed',
}

export enum PostNetworkSharingStatus {
  Published = PostNetworksModerationTabs.Published,
  Dismissed = PostNetworksModerationTabs.Dismissed,
}

export type PostNetworkApprovalForm = {
  networkProgramId: string;
  status: PostNetworkSharingStatus;
  onBehalfOfOrganizationId: string;
}